function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "vertical-align-bottom_svg__a",
  d: "M24.184 24c.727 0 1.316.448 1.316 1s-.59 1-1.316 1H1.816C1.089 26 .5 25.552.5 25s.59-1 1.316-1h22.368zM13 4c.552 0 1 .61 1 1.364v11.325l3.306.001a.5.5 0 01.41.788l-.056.066-4.308 4.307a.5.5 0 01-.638.058l-.069-.058-4.308-4.307a.5.5 0 01.268-.847l.086-.007L12 16.689V5.364C12 4.61 12.448 4 13 4z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "vertical-align-bottom_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#vertical-align-bottom_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#vertical-align-bottom_svg__a"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#vertical-align-bottom_svg__b)"
}, React.createElement("path", {
  d: "M-160-36.09h340v100h-340z"
})));

var SvgVerticalAlignBottom = function SvgVerticalAlignBottom(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 26 30"
  }, props), _ref, _ref2);
};

export default SvgVerticalAlignBottom;